const columns = {
  session: { id: "session", name: "Session", sortable: true, deselectable: false },
  group: { id: "group", name: "Group", sortable: true, deselectable: false },
  student: { id: "student", name: "Student", sortable: true, deselectable: false },
  lesson: { id: "lesson", name: "Lesson", sortable: true, deselectable: false },
  guardian: { id: "guardian", name: "Guardian", sortable: true, deselectable: false },
  comment: { id: "comment", name: "Comment", sortable: false, deselectable: false },
  booked: { id: "booked", name: "Booked", sortable: false, deselectable: false, align: "text-center" },
  available_slots: { id: "available_slots", name: "Available", sortable: false, deselectable: false, align: "text-center" },
  created_at: { id: "created_at", name: "Created", sortable: true, deselectable: true },
  actions: { id: "actions", name: "Actions", sortable: false, deselectable: false, align: "text-right" },
}

const defaultColumns = [
  "session",
  "group",
  "student",
  "lesson",
  "guardian",
  "comment",
  "booked",
  "available_slots",
  "created_at",
  "actions",
]

const downloadOptions = [
  { key: "xls", name: "Download All XLS" },
]

const filters = {
  booked: { id: "booked", name: "Booked" },
  not_booked: { id: "not_booked", name: "Not Booked" },
  bookable: { id: "bookable", name: "Bookable" },
  available_slots: { id: "available_slots", name: "Available Slots" },
  no_available_slots: { id: "no_available_slots", name: "No Available Slots" },
}

export { columns, defaultColumns, downloadOptions, filters }
